import { v1Api } from '@/api/backendApi';
export const trackReferralRegistration = () => {
  void v1Api.post('admin/user/partnerstack/customer/create', {});
};